module.exports = __webpack_public_path__ + "static/media/quote-bg-ogilvy.2e94477c.jpg";